import {ComponentType} from 'react'
import {appFactory} from '@modifi/app'
import {compose} from 'ramda'
import {withResponsiveProvider} from '@modifi/ui'
import {
  AUTH_TYPE_USER,
  CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL,
} from '@modifi/plugin-authentication/register'
import {clientConfig} from '@modifi/client-config'
import ms from 'ms'

import {withSuspense, withAbilityProvider} from './hoc'
import Layout from './layout'
import routes from './routes'
import reducers from './reducers'
import {initPlugins, PluginFactoryOpts} from './plugins'
import './dialogs/setup'

type AppFactoryOpts = {
  useSuspense?: boolean
  plugins?: PluginFactoryOpts
}

const getApp = async (options: AppFactoryOpts = {}): Promise<ComponentType> => {
  await initPlugins(options?.plugins)

  const hocFunc = options.useSuspense
    ? // @ts-expect-error bad withResponsiveProvider typing
      compose(withSuspense(true), withResponsiveProvider, withAbilityProvider)
    : // @ts-expect-error bad withResponsiveProvider typing
      compose(withResponsiveProvider, withAbilityProvider)

  clientConfig.set(CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL, ms('4m'))

  return appFactory({
    client: 'argus',
    appType: AUTH_TYPE_USER,
    routes,
    reducers,
    layout: Layout,
    // @ts-expect-error
    hoc: hocFunc,
  })
}

export default getApp
